import MuiAppBar from '@material-ui/core/AppBar';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import MuiTab from '@material-ui/core/Tab';
import MuiTabs from '@material-ui/core/Tabs';
import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { CONTAINER, HIGHLIGHT,LIGHT_GREY, TEXT } from '../Colors';
import { BODY, SUBTITLE } from '../Fonts';

const StyledMuiAppBar = withStyles({
    root: {
        borderRadius: 0,
        backgroundColor: CONTAINER,
        boxShadow: 'none'
    }
})(MuiAppBar);

const StyledMuiTabs = withStyles({
    indicator: {
        backgroundColor: HIGHLIGHT
    }
})(MuiTabs);

const StyledMuiTab = withStyles({
    root: {
        font: SUBTITLE,
        fontWeight: 600,
        textTransform: 'none',
        color: TEXT,
    },
    selected: {

    },
    disabled: {

    }
})(MuiTab);

const StyledRootDiv = styled.div`
    width: 100%;
    height: 100%;
    flex-direction: column;
    background: ${LIGHT_GREY};
`

const StyledTabDiv = styled.div`
    font: ${BODY},
    color: ${TEXT},
    width: 100%;
    height: 100%;
    flex: 1;
`
const useStyles = makeStyles({
    hidden: {
        display: 'none',
    },
    show: {
        display: 'flex',
    }
});

interface TabsProps {
    selectedTabKey: string,
    hidden?: boolean,
    onChange?(newSelectedTabKey: string): void
}

export const Tabs: React.FunctionComponent<TabsProps> = (props) => {
    const classes = useStyles();

    // "stylingClassName" is used for "styled components" extensions. It is hidden from the developer.
    const stylingClassName = (props as any).className ? (props as any).className : '';

    const onChange = (newSelectedTabKey: string) => {
        props.onChange(newSelectedTabKey);
    }

    const tabHeaders = (props.children as Array<ReactElement>).map(tp => <StyledMuiTab key={tp.props.tabKey} label={tp.props.label} disabled={tp.props.disabled} value={tp.props.tabKey} />);
    const tabs = (props.children as Array<ReactElement>).map(tp => <StyledTabDiv className='scroll' key={tp.props.tabKey} hidden={tp.props.tabKey !== props.selectedTabKey}>
            {tp}
    </StyledTabDiv>);

    const className = `${props.hidden ? classes.hidden : classes.show} ${stylingClassName}`;

    return (
        <StyledRootDiv className={className}>
            <StyledMuiAppBar position="relative">
                <StyledMuiTabs value={props.selectedTabKey} onChange={(e, v) => onChange(v)} variant="scrollable" scrollButtons="auto">
                    {tabHeaders}
                </StyledMuiTabs>
            </StyledMuiAppBar>
                {tabs}   
        </StyledRootDiv>
    );
}